define('app/dashboard/widgets/TableReportDashboardItemView',['require','./ReportDashboardItemView','glu/util','hbs!./TableReportDashboardItemView.hbs'],function(require) {

	'use strict';

	var ReportDashboardItemView = require('./ReportDashboardItemView'),
		_ = require('glu/util');

	return ReportDashboardItemView.extend({
		className: 'dashboard-item dashboard-basic-table-chart',
		template: require('hbs!./TableReportDashboardItemView.hbs'),

		initialize: function() {
			// call base class initialize function
			ReportDashboardItemView.prototype.initialize.call(this);

			this.model.set('isLoading', true);
			this.listenTo(this.model, 'dataReceived', this.dataReceived);
			this.listenTo(this.model, 'change', this.render);
		},

		onRender: function() {},

		dataReceived: function() {
			this.model.set('isLoading', false);
			this.render();
		},

		isLoading: function() {
			return this.model.get('isLoading');
		},

		columns: function() {
			var data = this.model.consumableResults().formattedData(),
				columnsData = data.header;

			return _.map(columnsData, function(column) {
				var prefixSum = (column.type === 'CURRENCY') ? '$' : '';

				return {
					name: column.name,
					nameClass: 'dt-' + column.type.toLowerCase(),
					total: column.type === 'STR' ? '' : '(' + prefixSum + column.total.toLocaleString() + ')'
				};
			});
		},

		rows: function() {
			var data = this.model.consumableResults().formattedData(),
				rowData = data.rows.slice(0, 10),
				styledRowData = _.map(rowData, function(item) {
					var cssClassRowArr = _.map(item, function(nestedItem, nestedIndex) {
						return {
							name: nestedItem,
							nameClass: 'dt-' + data.header[nestedIndex].type.toLowerCase()
						};
					});
					return cssClassRowArr;
				});
			return styledRowData;
		}
	});
});

